import { Menu } from "lucide-react"
import Link from "next/link"
import { ResoltoWordmark } from "./resolto-brand"
import { ThemeToggle } from "./theme-toggle"

const links = [
  { href: "/product", label: "Product" },
  { href: "/how-it-works", label: "How it works" },
  { href: "/integrations", label: "Integrations" },
  { href: "/security", label: "Security" },
  { href: "/pricing", label: "Pricing" },
]

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="marketing-container site-header-inner">
        <ResoltoWordmark />
        <nav className="desktop-site-nav" aria-label="Main navigation">
          {links.map((link) => (
            <Link key={link.href} href={link.href}>
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="site-header-actions">
          <ThemeToggle />
          <Link className="text-link desktop-only" href="/sign-in">
            Sign in
          </Link>
          <Link className="button button-primary desktop-only" href="/contact">
            Book a design-partner call
          </Link>
          <details className="mobile-site-menu">
            <summary className="icon-button" aria-label="Open navigation">
              <Menu aria-hidden="true" />
            </summary>
            <nav aria-label="Mobile navigation">
              {links.map((link) => (
                <Link key={link.href} href={link.href}>
                  {link.label}
                </Link>
              ))}
              <Link href="/sign-in">Sign in</Link>
              <Link className="button button-primary" href="/contact">
                Book a design-partner call
              </Link>
            </nav>
          </details>
        </div>
      </div>
    </header>
  )
}
